var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main', [_c('b-overlay', {
    attrs: {
      "show": _vm.loading
    }
  }, [_c('b-card-actions', {
    attrs: {
      "no-actions": true,
      "title": _vm.isEdit ? 'Ubah Catatan Analisis' : 'Tambah Catatan Analisis'
    }
  }, [_c('p', {
    staticClass: "mb-2 text-body"
  }, [_vm._v(" Catatan pengamatan sales untuk konsumen target yang belum deal — catat info konsumen dan brand/harga yang diamati. ")]), _c('validation-observer', {
    ref: "form"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }, [_vm._v("Info Konsumen")])]), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Pilih Sales",
      "label-for": "v-karyawan_id"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Sales",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref) {
        var errors = _ref.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-karyawan_id",
            "name": "karyawan_id",
            "state": errors.length > 0 ? false : null,
            "options": _vm.karyawanOptions,
            "disabled": _vm.isSalesLocked
          },
          model: {
            value: _vm.form.karyawan_id,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "karyawan_id", $$v);
            },
            expression: "form.karyawan_id"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tanggal & Waktu",
      "label-for": "v-tanggal"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Tanggal",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref2) {
        var errors = _ref2.errors;
        return [_c('flat-pickr', {
          staticClass: "form-control",
          attrs: {
            "id": "v-tanggal",
            "config": {
              enableTime: true,
              dateFormat: 'Y-m-d H:i'
            }
          },
          model: {
            value: _vm.form.tanggal,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tanggal", $$v);
            },
            expression: "form.tanggal"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Nama Customer / Konsumen",
      "label-for": "v-nama_costumer"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Nama konsumen",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref3) {
        var errors = _ref3.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-nama_costumer",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi nama customer / konsumen"
          },
          model: {
            value: _vm.form.nama_costumer,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "nama_costumer", $$v);
            },
            expression: "form.nama_costumer"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Tipe Konsumen",
      "label-for": "v-tipe_konsumen"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Tipe konsumen",
      "rules": {
        required: true
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref4) {
        var errors = _ref4.errors;
        return [_c('b-form-select', {
          attrs: {
            "id": "v-tipe_konsumen",
            "name": "tipe_konsumen",
            "state": errors.length > 0 ? false : null,
            "options": _vm.tipeOptions
          },
          model: {
            value: _vm.form.tipe_konsumen,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "tipe_konsumen", $$v);
            },
            expression: "form.tipe_konsumen"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "sm": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Kecamatan",
      "label-for": "v-kecamatan"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Kecamatan",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref5) {
        var errors = _ref5.errors;
        return [_c('b-form-input', {
          attrs: {
            "id": "v-kecamatan",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi kecamatan"
          },
          model: {
            value: _vm.form.kecamatan,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "kecamatan", $$v);
            },
            expression: "form.kecamatan"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "Alamat",
      "label-for": "v-alamat"
    }
  }, [_c('validation-provider', {
    attrs: {
      "name": "Alamat",
      "rules": "required"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(_ref6) {
        var errors = _ref6.errors;
        return [_c('b-form-textarea', {
          attrs: {
            "id": "v-alamat",
            "state": errors.length > 0 ? false : null,
            "placeholder": "Isi alamat"
          },
          model: {
            value: _vm.form.alamat,
            callback: function callback($$v) {
              _vm.$set(_vm.form, "alamat", $$v);
            },
            expression: "form.alamat"
          }
        }), _c('small', {
          staticClass: "text-danger"
        }, [_vm._v(_vm._s(errors[0]))])];
      }
    }])
  })], 1)], 1)], 1), _c('hr', {
    staticClass: "my-2"
  }), _c('b-row', {
    staticClass: "align-items-center mb-1"
  }, [_c('b-col', [_c('h5', {
    staticClass: "mb-0"
  }, [_vm._v("Brand Diamati")]), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(" Brand dan harga jual yang diamati di lokasi konsumen. ")])]), _c('b-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "size": "sm",
      "disabled": _vm.loading || _vm.removing
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.addBrand($event);
      }
    }
  }, [_c('feather-icon', {
    staticClass: "mr-50",
    attrs: {
      "icon": "PlusIcon"
    }
  }), _vm._v(" Tambah Brand ")], 1)], 1)], 1), !_vm.selectedBrands.length ? _c('div', {
    staticClass: "text-center text-muted py-3 border rounded mb-2"
  }, [_vm._v(" Belum ada brand. Klik "), _c('strong', [_vm._v("Tambah Brand")]), _vm._v(" untuk menambah catatan. ")]) : _c('b-table', {
    staticClass: "mb-2",
    attrs: {
      "fields": _vm.tableFields,
      "items": _vm.selectedBrands,
      "hover": "",
      "bordered": "",
      "striped": "",
      "small": "",
      "responsive": ""
    },
    scopedSlots: _vm._u([{
      key: "cell(no)",
      fn: function fn(_ref7) {
        var index = _ref7.index;
        return [_vm._v(" " + _vm._s(index + 1) + " ")];
      }
    }, {
      key: "cell(brand)",
      fn: function fn(_ref8) {
        var item = _ref8.item;
        return [_c('b-form-input', {
          attrs: {
            "placeholder": "Nama brand",
            "size": "sm"
          },
          model: {
            value: item.brand,
            callback: function callback($$v) {
              _vm.$set(item, "brand", $$v);
            },
            expression: "item.brand"
          }
        })];
      }
    }, {
      key: "cell(harga)",
      fn: function fn(_ref9) {
        var item = _ref9.item,
            index = _ref9.index;
        return [_c('b-form-input', {
          attrs: {
            "placeholder": "Harga",
            "size": "sm"
          },
          on: {
            "keyup": function keyup($event) {
              return _vm.doFormatRupiah(index);
            }
          },
          model: {
            value: item.harga,
            callback: function callback($$v) {
              _vm.$set(item, "harga", $$v);
            },
            expression: "item.harga"
          }
        })];
      }
    }, {
      key: "cell(action)",
      fn: function fn(_ref10) {
        var index = _ref10.index,
            item = _ref10.item;
        return [_c('b-button', {
          directives: [{
            name: "b-tooltip",
            rawName: "v-b-tooltip.hover.top",
            value: 'Hapus',
            expression: "'Hapus'",
            modifiers: {
              "hover": true,
              "top": true
            }
          }],
          attrs: {
            "size": "sm",
            "variant": "outline-danger",
            "disabled": _vm.loading || _vm.removing
          },
          on: {
            "click": function click($event) {
              $event.preventDefault();
              return _vm.removeBrand(index, item);
            }
          }
        }, [_c('feather-icon', {
          attrs: {
            "icon": "TrashIcon"
          }
        })], 1)];
      }
    }])
  }), _vm.brandError ? _c('small', {
    staticClass: "text-danger d-block mb-1"
  }, [_vm._v(" " + _vm._s(_vm.brandError) + " ")]) : _vm._e(), _c('div', {
    staticClass: "d-flex justify-content-end mt-2"
  }, [_c('b-button', {
    staticClass: "mr-1",
    attrs: {
      "variant": "outline-secondary",
      "disabled": _vm.loading || _vm.removing
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.goBack($event);
      }
    }
  }, [_vm._v(" Batal ")]), _c('b-button', {
    attrs: {
      "variant": "primary",
      "disabled": _vm.loading || _vm.removing
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.formSubmitted($event);
      }
    }
  }, [_vm.loading ? _c('b-spinner', {
    staticClass: "mr-50",
    attrs: {
      "small": ""
    }
  }) : _vm._e(), _vm._v(" " + _vm._s(_vm.isEdit ? "Ubah" : "Simpan") + " ")], 1)], 1)], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }